<div class="home_cls">
   <div class="home_title">
    <span>{{configList['title']}}系統</span>
   </div>
   <div class="home_remark">
    <div class="remark_content">{{configList['content1']}}</div>
    <div class="remark_content">{{configList['content2']}}</div>
   </div>
   <div class="home_content">
    <div class="am-list">
      <div class="am-list-body">
        <InputItem [type]="'text'" [content]="content1" [(ngModel)]="dataSample['emplid']" (onBlur)="filterSearch()">
          <ng-template #content1>
            <span style="color: red;">*</span>1.您的工号:
          </ng-template>
        </InputItem>
        <InputItem [type]="'text'" [content]="content" [(ngModel)]="dataSample['cname']" disabled >
          <ng-template #content>
            <span style="color: red;">*</span>2.您的姓名:
          </ng-template>
        </InputItem>
        <InputItem [type]="'text'" [content]="content2" [maxLength]="18" [(ngModel)]="dataSample['idcard']"  >
          <ng-template #content2>
            <span style="color: red;">*</span>3.您的身份证号码:
          </ng-template>
        </InputItem>
        <InputItem [type]="'phone'" [(ngModel)]="dataSample['phonenum']" [content]="content3" >
          <ng-template #content3>
            <span style="color: red;">*</span>4.您的手机号码:
          </ng-template>
        </InputItem>
        <InputItem [type]="'text'" [content]="content4" [(ngModel)]="dataSample['empDept']" disabled >
          <ng-template #content4>
            <span style="color: red;">*</span>5.您的部门:
          </ng-template>
        </InputItem>
        <!-- <ListItem
          Picker
          [extra]="tips1"
          [arrow]="'horizontal'"
          [data]="configList['dept']"
          [(ngModel)]="dataSample['empDept']"
          (ngModelChange)="getDept($event)"
        >
          <span style="color: red;">*</span>5.您的部门:
        </ListItem> -->
        <ListItem
          Picker
          [extra]="tips2"
          [arrow]="'horizontal'"
          [data]="configList['require']"
          [(ngModel)]="dataSample['empRequire']"
          (ngModelChange)="getRequire($event)"
        >
          <span style="color: red;">*</span>6.请填写您的需求:
        </ListItem>
        <ListItem
          Picker
          [extra]="tips3"
          [arrow]="'horizontal'"
          [data]="canSelectDateList"
          [title]="''"
          [(ngModel)]="dataSample['hopeQuitdate']"
          (ngModelChange)="getQuitDate($event)"
          *ngIf="dataSample['empRequire'] != '撤销申请'"
        >
          <span style="color: red;">*</span>7.您期望的离职日期是哪一天？
          <br><p style="font-size: 13px;font-weight: normal;">{{configList['leaveNotice']}}</p>
        </ListItem>
        <ListItem
          Picker
          [extra]="tips5"
          [arrow]="'horizontal'"
          [data]="configList['cancelReason']"
          [(ngModel)]="dataSample['quitReason']"
          (ngModelChange)="getQuitReason($event)"
          *ngIf="dataSample['empRequire'] == '撤销申请' && tips6 != '其他-其他（请填写具体事项）'"
        >
        <span style="color: red;">*</span>7.请问您撤销离职的原因:
        </ListItem>
        <ListItem
          Picker
          [extra]="tips4"
          [arrow]="'horizontal'"
          [data]="configList['reasonType']"
          [title]="''"
          [(ngModel)]="dataSample['reasonType']"
          (ngModelChange)="getReasonType($event)"
          *ngIf="dataSample['empRequire'] != '撤销申请'"
        >
          <span style="color: red;">*</span>8.请选择您离职原因的类别？
        </ListItem>
        <ListItem
          Picker
          [extra]="tips6"
          [arrow]="'horizontal'"
          [data]="quitReason"
          [title]="''"
          [(ngModel)]="dataSample['quitReason']"
          (ngModelChange)="getReasonDetail($event)"
          [disabled]="dataSample['reasonType']==''"
          *ngIf="dataSample['empRequire'] != '撤销申请' && tips6 != '其他-其他（请填写具体事项）'"
        >
          <span style="color: red;">*</span>9.请选择您具体的离职原因？
        </ListItem>
        <InputItem [type]="'text'" [(ngModel)]="dataSample['quitReason']" [content]="content4" *ngIf="dataSample['empRequire'] != '撤销申请' && tips6 == '其他-其他（请填写具体事项）'">
          <ng-template #content4>
            <span style="color: red;">*</span>9.请填写您具体的离职原因:
          </ng-template>
        </InputItem>
        <ListItem
          Picker
          [extra]="tips7"
          [arrow]="'horizontal'"
          [data]="configList['comment']"
          [title]="''"
          [(ngModel)]="dataSample['comment']"
          (ngModelChange)="getComment($event)"
          *ngIf="dataSample['empRequire'] != '撤销申请' && tips7 !== comment"
        >
          <span style="color: red;">*</span>10.公司做何种改善可考虑继续留任？
        </ListItem>
        <InputItem [type]="'text'" [(ngModel)]="dataSample['comment']" [content]="content5" *ngIf="dataSample['empRequire'] != '撤销申请' && tips7 == comment">
          <ng-template #content5>
            <span style="color: red;">*</span>10.请具体说明:
          </ng-template>
        </InputItem>
        <ListItem
          Picker
          [extra]="tips8"
          [arrow]="'horizontal'"
          [data]="configList['isInterviewed']"
          [title]="''"
          [(ngModel)]="dataSample['isInterviewed']"
          (ngModelChange)="getIsReview($event)"
          *ngIf="dataSample['empRequire'] != '撤销申请'"
        >
          <span style="color: red;">*</span>11.您在扫码之前是否被访谈留任过？
        </ListItem>
        <ListItem
          Picker
          [extra]="tips8"
          [arrow]="'horizontal'"
          [data]="configList['isInterviewed']"
          [title]="''"
          [(ngModel)]="dataSample['isInterviewed']"
          (ngModelChange)="getIsReview($event)"
          *ngIf="dataSample['empRequire'] == '撤销申请'"
        >
          <span style="color: red;" >*</span>8.您在扫码之前是否被访谈留任过？
        </ListItem>
        <InputItem 
          [type]="'text'" 
          [content]="content1" 
          [(ngModel)]="dataSample['talkerId']" 
          (onBlur)="filterSearchTalker()"
          *ngIf="dataSample['empRequire'] == '撤销申请' && dataSample['isInterviewed'][0] != null && dataSample['isInterviewed'][0]['label'] == '是'"
        >
          <ng-template #content1>
            <span style="color: red;">*</span>9.访谈人员工号:
          </ng-template>
        </InputItem>
        <InputItem 
          [type]="'text'" 
          [content]="content1" 
          [(ngModel)]="dataSample['talkerName']" 
          *ngIf="dataSample['empRequire'] == '撤销申请' && dataSample['isInterviewed'][0] != null && dataSample['isInterviewed'][0]['label'] == '是'"
        >
          <ng-template #content1>
            <span style="color: red;">*</span>10.访谈人员姓名:
          </ng-template>
        </InputItem>
        <WhiteSpace></WhiteSpace>
        <div Button [type]="'primary'" (click)="submitData()" *ngIf="!submit_disabled"><p style="color: #fff">提交</p></div>
        <div Button [type]="'primary'" [disabled]="submit_disabled" *ngIf="submit_disabled"><p style="color: #fff">提交</p></div>
      </div>
    </div>
    <div class="version">
      <span style="color: rgba(0, 0, 0, 0.315)">Frame Version 1.0.5</span>
    </div>
   </div>
</div>
